import React from "react"
import { cn } from "@/lib/utils"
import { Breadcrumbs, BreadcrumbsProps } from "@/components/breadcrumbs"

interface PageHeaderProps {
  title: string
  description?: string
  breadcrumbs?: BreadcrumbsProps["items"]
  action?: React.ReactNode
  className?: string
}

export function PageHeader({
  title,
  description,
  breadcrumbs,
  action,
  className,
}: PageHeaderProps) {
  return (
    <div className={cn("bg-background border-b", className)}>
      <div className="mx-auto max-w-5xl px-4 py-6 sm:px-6 lg:px-8">
        {breadcrumbs && (
          <div className="mb-4">
            <Breadcrumbs items={breadcrumbs} />
          </div>
        )}

        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div className="min-w-0 flex-1">
            <h1 className="text-foreground text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
              {title}
            </h1>
            {description && (
              <p className="text-muted-foreground mt-2 text-base sm:text-lg">
                {description}
              </p>
            )}
          </div>

          {action && <div className="flex-shrink-0">{action}</div>}
        </div>
      </div>
    </div>
  )
}
